<div class="full-size p-2">
  <app-cup-list class="content"></app-cup-list>
  <p class="footer">last update: {{timestamp | date}} ( {{sha}} )</p>
</div>
